import { StyledApp } from './globalStyles';
import { useAuth } from './hooks/Auth/useAuth';
import { useChatBot } from './hooks/ChatBot/useChatBot';
import { useRedirect } from './hooks/useRedirect';
import { Loading } from './shared/components/Loading/Loading';
import { useAuthStore } from './stores/AuthStore';
import { LOGIN_STATE } from './stores/Stores.consts';
import { AfterLogin } from './Views/AfterLogin/AfterLogin';
import { BeforeLogin } from './Views/BeforeLogin/BeforeLogin';
import { HelmetProvider } from 'react-helmet-async';
import { MetaTags } from './shared/seo';
import { Suspense, useEffect } from 'react';
import { setU1Configuration } from '@u1/react-a11y-hooks';
import i18n from './services/localization';
import { I18nextProvider } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLangStore } from './stores/LangStore/LangStore';
import { CookieBanner } from './shared/components/Banner/CookieBanner';
import { ThemeMode } from './stores/ThemeStore/ThemeStore.consts';
import { useThemeStore } from './stores/ThemeStore/ThemeStore';
import { useUserJourney } from './hooks/UserJourney/useUserJourney';
import { isBot } from './shared/utils';

export const App = () => {
  useChatBot();
  const loginState = useAuthStore((state) => state.loginState);
  const langStore = useLangStore();
  const themeStore = useThemeStore();
  const { lang } = useParams();
  const { loadingAuth } = useAuth();
  const { loadingToken } = useRedirect();
  const { handleUserJourney } = useUserJourney();
  const showCookiesBanner = !isBot(navigator.userAgent || '');

  useEffect(() => {
    // Theme
    const storedTheme = themeStore.getTheme();
    themeStore.setTheme(storedTheme);

    // Accessibility
    setU1Configuration({
      visualFocus: {
        style: {
          color: `${storedTheme === ThemeMode.DARK_MODE ? 'white' : 'black'}`,
        },
      },
    });

    //Journey cookies
    handleUserJourney();

    // Lang
    if (lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.setAttribute('dir', langStore.getLangDir() ?? 'ltr');
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<Loading />}>
        <HelmetProvider>
          <MetaTags />
          <StyledApp className="App">
            {loadingAuth || loadingToken || loginState === LOGIN_STATE.UNINITIATED ? (
              <Loading />
            ) : loginState === LOGIN_STATE.LOGGED_IN ? (
              <AfterLogin />
            ) : (
              <BeforeLogin />
            )}
            {showCookiesBanner && <CookieBanner />}
          </StyledApp>
        </HelmetProvider>
      </Suspense>
    </I18nextProvider>
  );
};
